export default __webpack_public_path__ + "static/media/circle-exit-red.289c1214.svg";